import React from "react";

/** Мини-тренд строки (порт sparkline, стр. 3965-3991 оригинала): корзины диапазона,
 * слева добивается нулями до 30 штрихов. */
export function Sparkline({ buckets }: { buckets: number[] }): React.ReactElement {
  const days = [...buckets];
  while (days.length < 30) days.unshift(0);
  const max = Math.max(1, ...days);
  return (
    <svg className="h-[22px] w-[72px]" viewBox="0 0 90 28" preserveAspectRatio="none">
      {days.map((value, index) => {
        const h = Math.max(2, Math.round((value / max) * 24));
        return (
          <rect
            key={index}
            x={index * 3}
            y={26 - h}
            width={2}
            height={h}
            rx={1}
            className="fill-sky-500/80 dark:fill-sky-400/80"
          />
        );
      })}
    </svg>
  );
}
